Vue.use(Vuex)
Vue.use(window['vue-img'])

const store = new Vuex.Store({
  state: {
    lookbooks: [],
    selectedLookbook: null,
    loading: true,
  },
  mutations: {
    UPDATE_SELECTED_LOOKBOOK(state, payload) {
      state.selectedLookbook = payload
    },
    UPDATE_LOADING(state, payload) {
      state.loading = payload
    },
    SET_LOOKBOOKS(state, payload) {
      state.lookbooks = payload
    },
  },
  actions: {
    fetchLookbooks(ctx) {
      // query lookbooks from sanity
      const lookbookQueryURL = 'https://u7c6377w.api.sanity.io/v1/data/query/production?query=*%5B_type%20%3D%3D%20%22lookbook%22%5D%20%7C%20order(publishedAt%20desc)%20%7B%0A%20%20_id%2C%0A%20%20_type%2C%0A%20%20title%2C%0A%20%20slug%2C%0A%20%20publishedAt%2C%0A%20%20%22cover%22%3A%20%7B%0A%20%20%20%20%22url%22%3A%20cover.asset-%3Eurl%2C%0A%20%20%09%22alt%22%3A%20cover.alt%2C%0A%20%20%7D%2C%0A%20%20%22images%22%3A%20images%5B%5D%7B%0A%20%20%09_key%2C%0A%20%20%09_type%2C%0A%20%20%09%22url%22%3A%20image.asset-%3Eurl%2C%0A%20%20%09%22alt%22%3A%20image.alt%2C%0A%20%20%09isSingle%2C%0A%20%20%09columnCount%2C%0A%20%20%09%22images%22%3A%20images%5B%5D%7B%0A%20%20%20%20%20%20%22url%22%3A%20asset-%3Eurl%2C%0A%20%20%20%20%20%20alt%2C%0A%20%20%20%20%7D%2C%0A%20%20%7D%2C%0A%7D'

      fetch(lookbookQueryURL)
        .then(response => response.json())
        .then((data) => {
          ctx.commit('SET_LOOKBOOKS', data.result)
          console.log('ctx.state.lookbooks', ctx.state.lookbooks)
        })
        .catch(err => console.log(err))
        .finally(() => {
          ctx.commit('UPDATE_LOADING', false)
        })
    }
  }
})

const LookbookList = {
  template: `
    <div class="lookbook__list">
      <router-link
        v-for="(lookbook, i) in $store.state.lookbooks" :key="'lb-item-' + i"
        :to="'/' + lookbook.slug.current"
        class="lookbook__list-item"
        :data-tippy-content="lookbook.title"
      >
        <img :src="lookbook.cover.url" :alt="lookbook.cover.alt" />
      </router-link>
    </div>
  `,
  mounted() {
    tippy('[data-tippy-content]', {
      followCursor: true,
    })
  },
}

const SingleLookbook = {
  template: `
    <div>
      <div class="lookbook__single" v-if="$store.state.selectedLookbook">
        <div
          v-for="(item, i) in $store.state.selectedLookbook.images"
          :key="'lb-image-' + i"
          class="lookbook__item"
        >
          <img
            v-if="item._type === 'lookbookImage'"
            :src="item.url"
            alt="item.alt"
            :class="{ 'is-single': item.isSingle }"
            v-img:lookbook="{ cursor: 'zoom-in' }"
            data-tippy-content="View Slideshow"
          >

          <div
            v-if="item._type === 'lookbookGrid'"
            :class="['lookbook__image-grid', 'cols-' + item.columnCount]"
          >
            <img
              v-for="(gridImage, k) in item.images"
              :key="'lb-image-' + i + '-' + k"
              :src="gridImage.url"
              alt="gridImage.alt"
              v-img:lookbook="{ cursor: 'zoom-in' }"
              data-tippy-content="View Slideshow"
            >
          </div>
        </div>
      </div>

      <div class="lookbook__none" v-else>
        👻 This lookbook doesn't exist.
        <router-link to="/">Back to Archive</router-link>
      </div>
    </div>
  `,
  props: ['images'],
  created() {
    const selected = this.$store.state.lookbooks.find(lb => lb.slug.current === this.$route.params.slug)
    this.$store.commit('UPDATE_SELECTED_LOOKBOOK', selected)
  },
  mounted() {
    tippy('[data-tippy-content]', {
      followCursor: true,
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('UPDATE_SELECTED_LOOKBOOK', null)
    next()
  },
}

const router = new VueRouter({
  routes: [
    { name: 'lookbook-list', path: '/', component: LookbookList, props: true },
    { name: 'single-lookbook', path: '/:slug', component: SingleLookbook, props: true },
  ]
})

new Vue({
  el: document.getElementById('lookbookApp'),
  delimiters: ['${', '}'],
  store,
  router,
  mounted() {
    store.dispatch('fetchLookbooks')
  } 
})

/*------ CURRENT GROQ QUERY

*[_type == "lookbook"] | order(publishedAt desc) {
  _id,
  _type,
  title,
  slug,
  publishedAt,
  "cover": {
    "url": cover.asset->url,
  	"alt": cover.alt,
  },
  "images": images[]{
  	_key,
  	_type,
  	"url": image.asset->url,
  	"alt": image.alt,
  	isSingle,
  	columnCount,
  	"images": images[]{
      "url": asset->url,
      alt,
    },
  },
}

------ */